

  $(document).ready(function(){
    $('#custom-opty-var').on('click', function() {
     
      $('#side-drawer').addClass('open');
    });

    $('.close-drawer').on('click', function() {
      $('#side-drawer').removeClass('open');
    });
    $('.side-drawer .variant-image-option input').on('change', function () {
      if ($(this).is(':checked')) {
        $('.side-drawer').removeClass('open');
      }
    });
    $('.overlay-right').on('click', function() {
          $('.side-cart-drawer').removeClass('open');
        });
      
        $(document).on('click', function(e) {
          if (!$(e.target).closest('#side-drawer, #custom-opty-var').length) {
            $('#side-drawer').removeClass('open');
          }
        });

        $('.opt-btn').on('change', function () {
      if ($(this).is(':checked')) {
        $('.side-cart-drawer').removeClass('open');
      }
    });

  });



document.addEventListener('DOMContentLoaded', function() {
  // Hover effect for variant images
  const variantOptions = document.querySelectorAll('.variant-image-option');
  
  variantOptions.forEach(option => {
    option.addEventListener('mouseenter', function() {
      const defaultImg = this.querySelector('.variant-default-img');
      const hoverImg = this.querySelector('.variant-hover-img');
      if (hoverImg) {
        defaultImg.style.opacity = '0';
        hoverImg.style.opacity = '1';
      }
    });
    
    option.addEventListener('mouseleave', function() {
      const defaultImg = this.querySelector('.variant-default-img');
      const hoverImg = this.querySelector('.variant-hover-img');
      if (hoverImg) {
        defaultImg.style.opacity = '1';
        hoverImg.style.opacity = '0';
      }
    });
  });
});


$(document).ready(function() {
  // Function to get selected variant data
  function getSelectedVariantData() {
    const $selected = $('.variant-image-option input[type="radio"]:checked').closest('.variant-image-option');
    
    if ($selected.length) {
      return {
        variantId: $selected.data('variant-id'),
        variantName: $selected.find('.js-value').text().trim(),
        imageSrc: $selected.find('.variant-default-img').attr('src'),
        hoverImageSrc: $selected.find('.variant-hover-img').attr('src') || null
      };
    }
    return null;
  }
  // Function to update the displayed variant info
  function updateVariantDisplay(selectedVariant) {
    if (selectedVariant) {    
      $('#selected-variant-name').text(selectedVariant.variantName);      
      const $imageContainer = $('.image-side img');
      $imageContainer.attr('src', selectedVariant.imageSrc); 
    }
  }

  // Initialize on page load
  const initialVariant = getSelectedVariantData();
  console.log("Initial selection:", initialVariant);
  updateVariantDisplay(initialVariant);

  // Update when selection changes
  $('.variant-image-option input[type="radio"]').change(function() {
    const selectedVariant = getSelectedVariantData();
    console.log("Selection changed:", selectedVariant);
    const selectedOption1 = $(`.the-var-selector option[value="${selectedVariant.variantId}"]`).attr('data-option1');
    const selectedOption2 = $(`.the-var-selector option[value="${selectedVariant.variantId}"]`).attr('data-option2');
    // setTimeout(()=>{
    //   $(`.js-product-form input[name="id"]`).attr('value', selectedVariant.variantId);
    // $(`.js-product-form input[name="id"]`).val(selectedVariant.variantId);
    // },200);
    // $(`.opt-btn []`).
    console.log('selected', selectedOption1, selectedOption2)
    updateVariantDisplay(selectedVariant);
  });
});


// ring-drawer

  document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.getElementById('custom-opty-ring');
    const drawer = document.getElementById('sizeDrawer');
    const closeBtn = document.getElementById('closeDrawer');

    if (trigger && drawer && closeBtn) {
      trigger.addEventListener('click', function () {
        drawer.classList.add('open');
      });

      closeBtn.addEventListener('click', function () {
        drawer.classList.remove('open');
      });

      // Optional: Close when clicking outside the drawer
      document.addEventListener('click', function (e) {
        if (!drawer.contains(e.target) && !trigger.contains(e.target)) {
          drawer.classList.remove('open');
        }
      });
    }
  });


$(".overlay-right").on('click', function(event){
   $(".rytdrawer ").removeClass("open");
});

$(".overlay-right").on('click', function(event){
   $(".side-drawer ").removeClass("open");
});


  $(document).ready(function() {
    $(".tab-content").hide();
    $(".tab-content:first").show();
    $(".tabs li:first").addClass("active");

    $(".tabs li").click(function() {
      var tabId = $(this).data('tab');
      $(".tabs li").removeClass("active");
      $(".tab-content").hide();

      $(this).addClass("active");
      $("#" + tabId).show();
    });
  });




$(".meta_accordions_item_heading").click(function () {
  $(this).toggleClass("open").next().slideToggle("fast");
  $(this)
    .parent()
    .siblings()
    .find(".meta_accordions_item_heading")
    .removeClass("open")
    .next()
    .slideUp("fast");
});

  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.slider__grid');
    const items = slider.querySelectorAll('.slider__item');
    const dots = document.querySelectorAll('.slider__dot');

    const updateDots = () => {
      const activeItem = slider.querySelector('.slider__item.is-active');
      if (!activeItem) return;

      const activeIndex = activeItem.getAttribute('data-dot-index');

      dots.forEach(dot => {
        dot.classList.toggle('is-active', dot.getAttribute('data-dot-index') === activeIndex);
      });
    };

    // Optional: hook this into your slider events
    const observer = new MutationObserver(updateDots);
    items.forEach(item => observer.observe(item, { attributes: true, attributeFilter: ['class'] }));

    // Optionally, update on dot click (if you support that)
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = dot.getAttribute('data-dot-index');
        items.forEach(item => {
          item.classList.toggle('is-active', item.getAttribute('data-dot-index') === index);
        });
        updateDots();
      });
    });
  });

$(document).on('change', '.opt-btn.is-unavailable', function () {
$('.opt-btn').on('change', function() {
  if ($(this).is(':checked')) {
    $('.rytdrawer').removeClass('open');
  }
});
 
});
$(document).ready(function() {
  $('.opt-btn').on('change', function() {
    if ($(this).is(':checked')) {
      $('.rytdrawer').removeClass('open');
    }
  });
});


// document.addEventListener('DOMContentLoaded', () => {
//   const left   = document.querySelector('.media-gallery .sticky-content-container');
//   const right  = document.querySelector('.product-column-right');
//   if (!left || !right) return;

//   const EXTRA  = 400;
//   const SCROLL_TRIGGER = 400;

//   function recalcHeights() {
//     const leftH = left.offsetHeight;
//     right.style.minHeight = (leftH + EXTRA) + 'px';
//   }

//   function toggleScrollClass() {
//     // console.log("📏 scrollY:", window.scrollY, "| trigger:", SCROLL_TRIGGER);
//     if (window.scrollY >= SCROLL_TRIGGER) {
//       right.classList.add('scrolled-past');
//       // console.log("✅ Class added");
//     } else {
//       right.classList.remove('scrolled-past');
//       // console.log("❌ Class removed");
//     }
//   }
//   recalcHeights();
//   toggleScrollClass();

//   window.addEventListener('resize', () => {
//     recalcHeights();
//     toggleScrollClass();
//   });

//   window.addEventListener('scroll', toggleScrollClass, { passive: true });
// });


// ===========Product Side bar Sticky Start ==========
// The product detail (right) column LEADS the scroll in both directions while
// the taller image (left) column follows:
//   • Scrolling down, the panel scrolls up through its own content until its
//     bottom edge reaches the bottom of the viewport, then pins there while the
//     left column keeps scrolling.
//   • Scrolling back up, it immediately reverses — bringing its top edge back
//     under the header first — and only once it's pinned at the top does the
//     left column resume scrolling.
//
// This uses native `position: sticky` and simply eases its `top` toward the
// bottom pin while scrolling down and toward the top pin while scrolling up.
// Sticky handles the flow-and-pin (and, crucially, the containment — the panel
// can't escape its column and overlap the section below) natively; nudging
// `top` in sync with the scroll adds the direction-aware reveal without any
// jumps. It's steadier than a JS transform (no sub-pixel jitter, no manual
// containment, and the top pin sits correctly below the header).
document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('.product-form.sticky-content-container');
  if (!panel) return;

  const TOP_GAP    = 30; // breathing room below the header when pinned to the top
  const BOTTOM_GAP = 30; // breathing room above the viewport bottom when pinned there

  // Height of the sticky header the panel should tuck beneath. Prefer the theme
  // variable; fall back to measuring the header element when it reads 0 (some
  // pages don't populate it), so the panel never pins up under the header.
  function measureHeaderHeight() {
    const raw = parseFloat(getComputedStyle(document.documentElement)
      .getPropertyValue('--theme-sticky-header-height')) || 0;
    if (raw > 0) return raw;
    const header = document.querySelector('.section-header') ||
                   document.getElementById('pageheader');
    if (header) {
      const r = header.getBoundingClientRect();
      if (r.top <= 1 && r.height > 0) return r.height;
    }
    return 0;
  }

  let headerH    = 0;
  let panelH     = 0;
  let prevScroll = window.scrollY;
  let stickTop   = null;   // the sticky `top` we're easing toward the active pin
  let appliedTop = null;   // last value actually written to the DOM
  let ticking    = false;

  function measure() {
    panelH  = panel.offsetHeight;
    headerH = measureHeaderHeight();
  }

  function setTop(v) {
    if (v !== appliedTop) {
      panel.style.top = v + 'px';
      appliedTop = v;
    }
  }

  function apply() {
    ticking = false;

    // Only relevant on the desktop two-column layout (see .product-info flex
    // rules); on mobile the columns stack and there's nothing to pin.
    if (window.innerWidth < 768) {
      if (appliedTop !== null) { panel.style.top = ''; appliedTop = null; }
      stickTop = null;
      prevScroll = window.scrollY;
      return;
    }

    const scrollY = window.scrollY;
    const delta   = scrollY - prevScroll;   // > 0 scrolling down, < 0 scrolling up
    prevScroll    = scrollY;

    const viewportH = window.innerHeight;
    const topPin    = TOP_GAP + headerH;                  // rest position under the header
    const botPin    = viewportH - panelH - BOTTOM_GAP;    // bottom-of-viewport rest position

    if (botPin >= topPin) {
      // Panel fits within the viewport: plain sticky just below the header.
      stickTop = topPin;
    } else {
      // Taller than the viewport: ease the stick point toward the bottom pin
      // when scrolling down and the top pin when scrolling up. Because the
      // panel is stuck while we ease, it tracks the scroll and reveals the
      // leading edge; reversing direction reverses the reveal immediately.
      if (stickTop === null) stickTop = topPin;
      if (delta > 0)      stickTop = Math.max(botPin, stickTop - delta);
      else if (delta < 0) stickTop = Math.min(topPin, stickTop - delta);
      if (stickTop < botPin) stickTop = botPin;
      else if (stickTop > topPin) stickTop = topPin;
    }

    setTop(stickTop);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(apply);
    }
  }

  // A layout change can shift the panel/header heights; re-measure then re-apply.
  function remeasure() {
    measure();
    apply();
  }

  measure();
  apply();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', remeasure, { passive: true });
  window.addEventListener('load', remeasure);

  // Re-measure when the panel's own height changes: accordions expanding
  // (Description, Return Policy…), variant swaps, or late-loading fonts/images.
  if ('ResizeObserver' in window) {
    new ResizeObserver(remeasure).observe(panel);
  }
});
// ===========Product Side bar Sticky End ==========



$(document).ready(function () {
    $('.custom-new-opt').on('click', function () {
      $('#sideCartDrawer').addClass('open');
    });

    $('.close-cart').on('click', function () {
      $('#sideCartDrawer').removeClass('open');
    });

    // Optional: click outside to close
    $(document).on('click', function (e) {
      if (
        !$(e.target).closest('#sideCartDrawer').length &&
        !$(e.target).closest('.custom-new-opt').length
      ) {
        $('#sideCartDrawer').removeClass('open');
      }
    });
  });




document.addEventListener('DOMContentLoaded', function () {
  const firstOptionFieldset = document.querySelector('.option-selector[data-is-first-option]');
  const firstOptionInputs = firstOptionFieldset?.querySelectorAll('input.js-option');

  document.querySelectorAll('.option-selector:not([data-is-first-option]) input.js-option').forEach(input => {
    input.addEventListener('change', function () {
      if (!firstOptionInputs) return;

      const isAnyFirstOptionChecked = Array.from(firstOptionInputs).some(input => input.checked);

      if (!isAnyFirstOptionChecked) {
        const firstInput = Array.from(firstOptionInputs).find(input => !input.disabled);
        if (firstInput) {
          firstInput.checked = true;
          firstInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
});

 